export const API_PASSWORD = "Project102$_";
